module.exports = __webpack_public_path__ + "static/org_bvcc-a113cdf7c4d69eec3f5c60cb079b7c0d.png";